module.exports = __webpack_public_path__ + "img/kehushuo-bg.55105045.png";